import styled from 'foundations-theming/utils';
// Ref: https://git.hubteam.com/HubSpot/universal-associations-select/blob/d17fdf79f96334407c0392d2329855397e324744/universal-associations-select/static/js/helpers/ShinySkeletonText.ts#L5

import SkeletonText from './SkeletonText';
export const ShinySkeletonText = styled(SkeletonText).withConfig({
  displayName: "ShinySkeletonText",
  componentId: "skcp6h-0"
})(["background:", ";background:linear-gradient( to right,", ",", " 20%,", " 40% );background-size:1200px;"], ({
  theme
}) => theme.color['fill-field-default'], ({
  theme
}) => theme.color['fill-field-default'], ({
  theme
}) => theme.color['fill-tertiary-default'], ({
  theme
}) => theme.color['fill-field-default']);